import { mountVueWithPinia } from '../vue/mountVue';
import Results from '../vue/Search/SearchResults.vue';

class SearchResults extends HTMLElement {
  constructor() {
    super();

    const app = document.querySelector('.js-search-results');
    const jsonScript = document.querySelector('.js-search-json');
    if (!app || !jsonScript) return;
    app.setAttribute('props-data', jsonScript.innerHTML);
    mountVueWithPinia('.js-search-results', Results, this);
  }
}

customElements.define('search-results', SearchResults);
